export default "__VITE_ASSET__841bccec__"